module.exports = __webpack_public_path__ + "static/img/GemmaHoughton.e583fb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GemmaHoughton.jpg
// module id = Zcee
// module chunks = 0